import {defineMessages} from 'react-intl';

export default defineMessages({
	navigationViewAll: {
		id: 'navigation.viewAll',
		defaultMessage: 'View All',
	},
});
